import LegalLayout, { LEGAL_META } from "./LegalLayout";

const { CONTACT_EMAIL } = LEGAL_META;

export default function Cookies() {
  return (
    <LegalLayout
      title="Política de Cookies"
      subtitle="Detalle de las cookies y tecnologías similares que utilizamos en el sitio SIGSAOP, en cumplimiento de la Ley N° 21.719 y los estándares internacionales de privacidad."
    >
      <h2>1. ¿Qué son las cookies?</h2>
      <p>
        Una cookie es un pequeño archivo de texto que un sitio web guarda en tu navegador. Las cookies permiten recordar
        tu actividad y preferencias entre sesiones, y son ampliamente utilizadas para hacer funcionar los sitios web o
        mejorar su rendimiento.
      </p>

      <h2>2. Base de licitud</h2>
      <p>
        Utilizamos cookies estrictamente necesarias sin requerir consentimiento previo, y cookies opcionales solo con tu
        consentimiento explícito, en cumplimiento del art. 12 de la Ley N° 21.719 (Chile).
      </p>

      <h2>3. Cookies que utilizamos</h2>

      <h3>3.1 Cookies estrictamente necesarias (no requieren consentimiento)</h3>
      <p>Son imprescindibles para el funcionamiento de la plataforma:</p>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem", fontSize: "0.9rem" }}>
        <thead style={{ background: "#f8fafc" }}>
          <tr>
            <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Nombre</th>
            <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Propósito</th>
            <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Duración</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}><code>sigsaop_token</code></td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Token JWT de sesión autenticada.</td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>24 horas</td>
          </tr>
          <tr>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}><code>sigsaop_user</code></td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Datos básicos del usuario logueado (nombre, rol, organización).</td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Sesión</td>
          </tr>
          <tr>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}><code>sigsaop_impersonating</code></td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Contexto de impersonación de Super Admin.</td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Sesión</td>
          </tr>
          <tr>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}><code>sigsaop_cookie_consent</code></td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>Registro de tu decisión sobre cookies opcionales.</td>
            <td style={{ padding: "10px", borderBottom: "1px solid #e2e8f0" }}>12 meses</td>
          </tr>
        </tbody>
      </table>
      <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#64748b" }}>
        Nota técnica: en el navegador utilizamos <code>localStorage</code> en lugar de cookies HTTP para las credenciales
        de sesión. El estándar legal las trata de forma equivalente ("tecnologías similares").
      </p>

      <h3>3.2 Cookies analíticas (requieren consentimiento)</h3>
      <p>
        Actualmente <strong>no utilizamos cookies de análisis, publicidad ni de terceros</strong>. Si en el futuro
        incorporamos servicios como Google Analytics, actualizaremos esta política y solicitaremos tu consentimiento
        explícito antes de activarlas.
      </p>

      <h3>3.3 Cookies publicitarias o de tracking</h3>
      <p>No utilizamos cookies de publicidad, retargeting, ni de terceros con fines comerciales.</p>

      <h2>4. Cómo gestionar y revocar el consentimiento</h2>
      <ul>
        <li>Cuando visitas el sitio por primera vez, aparece un banner con opciones "Aceptar" o "Rechazar" cookies opcionales.</li>
        <li>Puedes cambiar tu decisión en cualquier momento borrando la cookie <code>sigsaop_cookie_consent</code>
          desde la configuración de tu navegador (verás el banner nuevamente en tu próxima visita).</li>
        <li>Los principales navegadores permiten bloquear o eliminar cookies desde su panel de configuración:
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/eliminar-cookies-datos-sitios-firefox" target="_blank" rel="noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noreferrer">Microsoft Edge</a></li>
          </ul>
        </li>
      </ul>

      <h2>5. Consecuencias del rechazo</h2>
      <p>
        Rechazar las cookies estrictamente necesarias implica que <strong>no podrás iniciar sesión ni utilizar la
        plataforma</strong>, ya que estas cookies son técnicas e imprescindibles. Rechazar cookies opcionales no afecta
        el uso del servicio.
      </p>

      <h2>6. Cambios a esta política</h2>
      <p>
        Podemos actualizar esta política ante cambios en la normativa o en las tecnologías que utilizamos. La fecha de
        última actualización se muestra al inicio del documento.
      </p>

      <h2>7. Contacto</h2>
      <p>
        Consultas relacionadas con cookies o tratamiento de datos: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalLayout>
  );
}
